import { post,put,get,deleteRequest, postfd } from "../../../helpers/apihelpers";

export const UploadManagedOfficeAttachmentService=async(data)=>{
    try {
        const result = await postfd(`api/database/managed_office/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const CreateManagedOfficeService=async(data)=>{
    try {
        const result = await post(`api/database/managed_office/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateManagedOfficeService=async(data,id)=>{
    try {
        const result = await put(`api/database/managed_office/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetManagedOfficeService=async(page,from_date,to_date,text,step,base_type,status,zone,location_based_zone,user,facility_type,oc_availability)=>{
    try {
        const locationParam = Array.isArray(location_based_zone)
        ? location_based_zone.join(',')
        : location_based_zone;
  
        const result = await get(`api/database/managed_office/get?page=${page}&from_date=${from_date}&to_date=${to_date}&text=${text}&step=${step}&base_type=${base_type}&status=${status}&zone=${zone}&location_based_zone=${location_based_zone}&added_by=${user}&facility_type=${facility_type}&oc_availability=${oc_availability}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetManagedOfficeDetailService=async(id)=>{
    try {
        const result = await get(`api/database/managed_office/get/${id}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteManagedOfficeService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/managed_office/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteAdminManagedOfficeService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/managed_office/delete_admin/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteMassManagedOfficeService=async(data)=>{
    try {
        const result = await post(`api/database/managed_office/deleteMassMany`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const FilterManagedOfficeService=async(id)=>{
    try {
        const result = await get(`api/database/managed_office/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadManagedOfficeExcelService=async(data)=>{
    try {
        const result = await postfd(`api/database/managed_office/upload_excel`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadManagedOfficeExcelService1=async(data)=>{
    try {
        const result = await postfd(`api/database/managed_office/upload_excel1`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GenerateManagedOfficePPTService=async(data)=>{
    try {
        const result = await post(`api/database/managed_office/generate_ppt`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetManagedOfficeHistoryService=async(page,id)=>{
    try {
        const result = await get(`api/database/managed_office/managed_office_history/${id}?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    } 
}

export const UpdateManagedOfficeHistoryService=async(id,data)=>{
    try {
        const result = await put(`api/database/managed_office/managed_office_history/${id}`,data);
        return result;
    } catch (err) {
        return err.response;
    } 
}

export const DeleteManagedOfficeHistoryService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/managed_office/managed_office_history/${id}`);
        return result;
    } catch (err) {
        return err.response;
    } 
}
